import CosmosJobsDbRecordBase from '@/models/CosmosJobsDbRecordBase'
import ContactNumber from '@/models/contractor/ContactNumber'
export default class ThirdPartyAppointedContractor extends CosmosJobsDbRecordBase {
  public forEmergencyTypeId: number
  public forEmergencyDetailId: number
  public emergencyId: string
  public contractorId: string
  public companyName: string
  public contactNumbers: ContactNumber[]
  public status: string
}
